import { applyJitter } from "./helpers.mjs";
//#region src/backoff-strategy/linear-fully-jittered.ts
/**
* Linear backoff with AWS-style full jitter.
*
* - `baseDelay = min(maxDelay, delay * attempt)` for attempt < `maxAtAttempt`
* - `baseDelay = maxDelay` once attempt >= `maxAtAttempt` (default 100)
*
* Returned delay is uniformly drawn from `[0, baseDelay]`. With `attempt = 1`
* (the first retry) the base equals `delay`.
*
* See https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
*/
const linearBackoffFullyJittered = (options) => {
	const { delay, maxDelay, maxAtAttempt = 100 } = options;
	return (attempt) => {
		const baseDelay = attempt < maxAtAttempt ? Math.min(maxDelay, delay * attempt) : maxDelay;
		return applyJitter(baseDelay);
	};
};
//#endregion
export { linearBackoffFullyJittered };
